'use strict';
import * as T from 'prop-types';
import React from 'react';


export function ReactModalView(props) {
  return (
    <div
      className="modal-backdrop active"
      onClick={props.onClickBackdrop}
    >
      {props.children}
    </div>
  );
}

ReactModalView.propTypes = {
  className: T.string,
};

ReactModalView.defaultProps = {
  className: '',
};



// WEBPACK FOOTER //
// ./src/js/components/modals/ReactModal/ReactModalView.js